import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref, computed } from 'vue'
import type { ClueReceiveListItem } from '@/typings/api/marketingManage'
import Modal from '@/hooks/modalType'
import { message } from '@dc-platform/dc-components'
import { clueReceiveGet, clueReceiveDelete } from '@/api/marketing/marketingManage'
import AddEditModal from './components/addEditModal.vue'
import CustomerAreaCascaderText from '@/components/CustomerAreaCascader/CustomerAreaCascaderText.vue'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'

const __default__ = { name: 'DcCosFbuMarketClueReceive' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const addEditModalRef = ref()
const tableRef = ref()
const searchFrom = ref<any>({})
const fetch = (params: object, callBack: (res: any) => void) => {
  clueReceiveGet(params).then((res) => {
    callBack(res)
  })
}
// 新增
const handleAdd = () => {
  addEditModalRef.value.toggle()
}
// 编辑
const handleEdit = (record: ClueReceiveListItem) => {
  addEditModalRef.value.toggle(record)
}
const deleteRow = (record: ClueReceiveListItem) => {
  Modal.delete({
    onOk() {
      clueReceiveDelete({ id: record.id }).then(() => {
        message.success('删除成功')
        tableRef.value.delFetch()
      })
    }
  })
}
const success = (type?: 'search' | 'fetch') => {
  if (type === 'search') {
    tableRef.value.search()
  } else {
    tableRef.value.fetch()
  }
}
const columns = computed(() => [
  {
    title: '员工名称',
    dataIndex: 'userName',
    fixed: 'left'
  },
  {
    title: '员工工号',
    dataIndex: 'employeeNo'
  },
  {
    title: '上级名称',
    dataIndex: 'managerName'
  },
  {
    title: '部门',
    dataIndex: 'deptName',
    width: 190
  },
  {
    title: '线索接收区域',
    dataIndex: 'areaId',
    width: 350
  },
  {
    title: '操作人',
    dataIndex: 'operatorName'
  },
  {
    title: '操作时间',
    dataIndex: 'createTime',
    width: 190
  },
  {
    title: '操作',
    dataIndex: 'action',
    fixed: 'right',
    width: 120
  }
])

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_cos_table, {
            rowKey: "clueReceiveRecordId",
            columns: columns.value,
            serial: "",
            onFetch: fetch,
            ref_key: "tableRef",
            ref: tableRef,
            tableId: "DcCosFbuClueReceive",
            search: searchFrom.value,
            "onUpdate:search": _cache[3] || (_cache[3] = ($event: any) => ((searchFrom).value = $event))
          }, {
            search: _withCtx(() => [
              _createVNode(_component_a_form, { model: searchFrom.value }, {
                default: _withCtx(() => [
                  _createVNode(_component_dc_form_item, { label: "员工工号" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: searchFrom.value.employeeNo,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((searchFrom.value.employeeNo) = $event)),
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "员工名称" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: searchFrom.value.userName,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((searchFrom.value.userName) = $event)),
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "线索接收区域" }, {
                    default: _withCtx(() => [
                      _createVNode(CustomerAreaCascader, {
                        appId: "cos_fbu",
                        type: "search",
                        deptInfoId: "815717",
                        multiple: false,
                        ids: searchFrom.value.areaList,
                        "onUpdate:ids": _cache[2] || (_cache[2] = ($event: any) => ((searchFrom.value.areaList) = $event))
                      }, null, 8, ["ids"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            button: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                onClick: handleAdd,
                type: "primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 新增 ")
                ]),
                _: 1
              })), [
                [_directive_permission, 'fbu_marketing_clueReceive_add_btn']
              ])
            ]),
            bodyCell: _withCtx(({ column, record, text }) => [
              (column.dataIndex === 'action')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                      type: "link",
                      onClick: ($event: any) => (handleEdit(record))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 分配区域 ")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])), [
                      [_directive_permission, 'fbu_marketing_clueReceive_allocation_btn']
                    ]),
                    _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                      type: "link",
                      onClick: ($event: any) => (deleteRow(record))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 删除 ")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])), [
                      [_directive_permission, 'fbu_marketing_clueReceive_delete_btn']
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (column.dataIndex === 'areaId')
                ? (_openBlock(), _createBlock(CustomerAreaCascaderText, {
                    key: 1,
                    appId: "cos_fbu",
                    lastLeval: true,
                    multiple: true,
                    deptInfoId: "815717",
                    value: text
                  }, null, 8, ["value"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["columns", "search"]),
          _createVNode(AddEditModal, {
            ref_key: "addEditModalRef",
            ref: addEditModalRef,
            onSuccess: success
          }, null, 512)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})